import { useTranslation, Trans } from "react-i18next";

import { Button, EmptyState, Link, Spacer } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { useBreakpoints } from "@shared/hooks";
import { useSearchParams } from "@shared/react-router-dom";
import { l } from "@unauthenticated/wellevateAuthorize/practitioners/locales/i18n";
import { AccountCreationStep } from "@unauthenticated/wellevateAuthorize/practitioners/types";

import * as styles from "./WellevateAccountErrorPage.styles";

interface Props {
  email: String;
}

const WellevateAccountErrorPage = ({ email }: Props) => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();
  const [, setSearchParams] = useSearchParams();
  const isMobile = phoneLarge.lessThan;

  return (
    <EmptyState
      illustration="bell"
      header={t(l.common.WellevateAccountErrorPage.title, {
        wellevateEmail: email,
      })}
      action={
        <>
          <Button
            isColor="system"
            isFullWidth={isMobile}
            onClick={() => setSearchParams({ step: AccountCreationStep.WELLEVATE_AUTH })}
          >
            {t(l.common.WellevateAccountErrorPage.buttons.goBack)}
          </Button>
          <Spacer css={styles.spacer} />
          <Button isFullWidth={isMobile} href="/">
            {t(l.common.WellevateAccountErrorPage.buttons.signIn)}
          </Button>
        </>
      }
    >
      <Trans i18nKey={l.common.WellevateAccountErrorPage.subTitle}>
        This email address has already been used to connect a Wellevate account to a Fullscript
        account. You can go back and choose another email, or use your Fullscript credentials to
        sign in. Need help?
        <Link href={sharedRoutes.external.wellevateMigrationSupport} noExternalIcon>
          Contact us
        </Link>
        .
      </Trans>
    </EmptyState>
  );
};

export { WellevateAccountErrorPage };
